import { downloadContratoDocx } from '@/lib/contratoDocxExport';

function slugEditalPart(label) {
  const base = String(label ?? '').trim() || 'edital';
  const slug = base
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
  return slug || 'edital';
}

/**
 * Gera e dispara o download de um .DOCX com o texto integral da minuta (uma linha = um parágrafo no Word).
 * @param {string} minutaText
 * @param {{ editalLabel?: string, tipoSuffix?: string }} [opts]
 */
export async function downloadManifestoMinutaDocx(minutaText, opts = {}) {
  const { editalLabel = '', tipoSuffix = 'impugnacao' } = opts;
  const raw = String(minutaText ?? '').trim();
  if (!raw) {
    throw new Error('Não há conteúdo na minuta para exportar.');
  }
  const data = new Date().toISOString().slice(0, 10);
  const slug = slugEditalPart(editalLabel);
  const filename = `minuta-${tipoSuffix}-${slug}-${data}.docx`;
  await downloadContratoDocx(raw, filename);
}
